<template>
  <div v-if="commonData" class="base-states-screen">
    <page-header :title="$t('app.base_states.title')"/>
    <div class="row mt-20">
      <div class="col-sm-6">
        <search-input
          :placeholder="$t('app.base_states.search_input_placeholder')"
          @input="search"
        />
      </div>
      <div v-if="sites.length > 0" class="col-sm-6 text-right">
            <base-button
              v-if="hasPermission && editable"
              :title="$t(`app.base_states.finalize`)"
              :classNames="`btn btn-success rounded pull-right`"
              @clicked="updateBaseStateStatus"
            />
            <base-button
              v-if="hasPermission && editable"
              :title="$t(`app.base_states.plan_base_state`)"
              :classNames="`btn btn-default rounded pull-right`"
              @clicked="planBaseState"
            />
            <base-button
              v-if="hasPermission && !editable"
              :title="$t(`app.base_states.new_base_state`)"
              :classNames="`btn btn-orange rounded pull-right`"
              @clicked="newBaseState"
            />
        <base-button
          v-if="editable"
          :title="$t('app.statements.create_title')"
          classNames="btn btn-orange rounded pull-right"
          @clicked="clickedCreateStatement"
        />
      </div>
    </div>
    <div v-if="sites.length > 0" class="row mt-20">
      <div class="col-md-4">
        <div class="form-group">
          <div class="col-md-12">
            <base-dropdown
              v-model="siteId"
              :defaultValue="sites.length > 0 ? sites[0].value : null"
              :list="sites"
              :needDefaultValue="false"
              labelClassNames="control-label mb-10 text-left"
              :labelValue="$t(`app.inspections.attributes.site_id`)"
              @input="siteIdChanged"
            />
          </div>
        </div>
      </div>
    </div>
    <ul v-if="sites.length > 0 && treeData.length > 0" class="cd-accordion-menu">
      <li>
        <label>
          <div class="row">
            <div class="col-md-12 header-row">
              <div class="col-md-1">
                {{$t('app.tables.baseState.identifier')}}
              </div>
              <div class="col-md-1">
                {{$t('app.tables.baseState.name')}}
              </div>
              <div class="col-md-2">
                {{$t('app.tables.baseState.statement_identifier')}}
              </div>
              <div class="col-md-3">
                {{$t('app.tables.baseState.statement')}}
              </div>
              <div class="col-md-3">
                {{$t('app.tables.baseState.question')}}
              </div>
              <div class="col-md-2">
                {{$t('app.tables.baseState.location')}}
              </div>
              <div class="col-md-1 extra-row">
                {{$t('app.tables.global.actions')}}
              </div>
            </div>
          </div>
        </label>
      </li>
      <statement-item
        v-for="(data,index) in treeData"
        :selectedIndex="index"
        :key="index"
        :bus="bus"
        :model="data"
        :needAction="editable"/>
    </ul>
    <div class="empty-section" v-if="!isLoading && (sites.length === 0 || treeData.length === 0)">{{$t('app.base_states.no_result')}}</div>
  </div>
</template>

<script>
import Vue from 'vue';

import { mapActions, mapGetters } from 'vuex';
import BaseDropdown from '@/components/shared/inputs/BaseDropDown';
import SearchInput from '@/components/shared/inputs/SearchInput';
import BaseButton from '@/components/shared/buttons/BaseButton';
import GenericForm from '@/components/shared/forms/GenericForm';
import PageHeader from '@/components/shared/layouts/PageHeader';
import StatementItem from './StatementItem';

export default {
  name: 'BaseStatesScreen',
  components: {
    'search-input': SearchInput,
    'base-button': BaseButton,
    'page-header': PageHeader,
    'statement-item': StatementItem,
    BaseDropdown,
  },
  data() {
    return {
      treeData: [],
      bus: new Vue(),
      currentPageIndex: 1,
      searchTerm: '',
      allVerificationQuestions: [],
      newStatement: {
        identifier: null,
        statement: null,
        criteria_category_id: null,
        sub_criteria_category_id: null,
        verification_question_id: null,
        locations: [],
      },
      sites: [],
      siteId: undefined,
      baseStateStatus: undefined,
      currentBaseStateId: undefined,
      allSite: undefined,
      editable: false,
      selectedSite: undefined,
    };
  },
  created() {
    this.$eventBus.showLoading(this.$t('app.base_states.baseStateLoading'));
    this.fetchCommonData(this.loggedInUser.partner_id).then(() => {
      this.$eventBus.hideLoading({});
    });
    this.fetchSites({
      partnerId: this.loggedInUser.partner_id,
      pageIndex: null,
      searchTerm: '',
      orderInfo: {
        order: 'created_at',
        direction: 'ASC',
      },
      isMobile: true,
    }).then((response) => {
      this.allSite = response;
      this.selectedSite = response[0];
      if (this.allSite.length > 0) {
        this.currentBaseStateId = this.allSite[0].current_base_state_id;
      }
      this.sites = response.map(x => ({ value: x.id, text: this.$t(x.name) }));
      if (this.sites.length > 0) {
        this.siteId = this.sites[0].value;
      } else {
        this.siteId = null;
      }
      this.baseStateStatus = response.filter(x => x.id === this.siteId)[0].base_state_status;
      this.editable = this.baseStateStatus !== 'finalized';
    });
    this.fetchCriteriaCategoryTree({ forStatement: true }).then((response) => {
      this.isLoading = false;
      this.treeData = response;
    });
    this.fetchCriteriaCategories({
      pageIndex: this.currentPageIndex,
      searchTerm: this.searchTerm,
    });
    this.bus.$on('getChild', (id, index) => {
      this.fetchCriteriaCategoryTreeChild({ id, forstatement: true, siteId: this.siteId }).then((response) => {
        this.treeData[index].children = [...response.statements, ...response.sub_categories];
        this.treeData[index].children.forEach((child) => {
          if (child.children && child.children.length > 0) {
            child.children.forEach((x) => {
              x.main_idx = index;
            });
          }
        });
      });
    });
    this.bus.$on('deleteStatementForSub', (mainIndex, parentIndex, selectedIndex) => {
      this.treeData[mainIndex].children[parentIndex].children.splice(selectedIndex, 1);
    });
    this.bus.$on('deleteStatement', (parentIndex, selectedIndex) => {
      this.treeData[parentIndex].children.splice(selectedIndex, 1);
    });
    this.bus.$on('updateStatementForSub', (mainIndex, parentIndex, selectedIndex, statement) => {
      this.treeData[mainIndex].children[parentIndex].children[selectedIndex].statement = statement.statement;
      this.treeData[mainIndex].children[parentIndex].children[selectedIndex].verification_question_name = statement.verification_question_name;
    });
    this.bus.$on('updateStatement', (parentIndex, selectedIndex, statement) => {
      this.treeData[parentIndex].children[selectedIndex].statement = statement.statement;
      this.treeData[parentIndex].children[selectedIndex].verification_question_name = statement.verification_question_name;
    });
  },
  computed: {
    ...mapGetters({
      allCriteriaCategories: 'criteriaCategories/allCriteriaCategories',
      commonData: 'partners/commonData',
      loggedInUser: 'loggedInUser',
    }),
    hasPermission() {
      return this.loggedInUser.role !== 'worker';
    },
    statementAttributes() {
      return [
        {
          name: 'statement',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'criteria_category_id',
          type: 'dropdown',
          action: 'selectCategory',
          dropdownList: this.categoriesForList,
          classes: 'col-md-6',
        },
        {
          name: 'sub_criteria_category_id',
          type: 'dropdown',
          action: 'selectSubCategory',
          dropdownList: this.subCategoriesForList,
          classes: 'col-md-6',
        },
        {
          name: 'verification_question_id',
          type: 'dropdown',
          dropdownList: this.questionsForList,
          classes: 'col-md-6',
        },
        {
          name: 'locations',
          type: 'tag',
          list: this.locationsForList,
        },
      ];
    },
    questionsForList() {
      if (this.allVerificationQuestions) {
        const mappedQuestions = this.allVerificationQuestions.map(question => ({
          value: question.id,
          text: question.name,
        }));
        return mappedQuestions;
      }
      return [];
    },
    categoriesForList() {
      if (!this.commonData || !this.commonData.criteria_category_list) {
        return [];
      }
      const mappedCategories = this.commonData.criteria_category_list.filter(category => category.parent_id === null).map(
        category => ({
          value: category.id,
          text: category.name,
        }),
      );
      return mappedCategories;
    },
    subCategoriesForList() {
      if (!this.commonData || !this.commonData.criteria_category_list) {
        return [];
      }
      const mappedCategories = this.commonData.criteria_category_list.filter(category => category.parent_id !== null).map(
        category => ({
          value: category.id,
          text: category.name,
        }),
      );
      return mappedCategories;
    },
    locationsForList() {
      return this.selectedSite.locations.map(location => ({
        id: location.id,
        text: location.name,
      }));
    },
  },
  methods: {
    ...mapActions({
      CriteriaCategoryForStatementTreeSearch: 'criteriaCategories/CriteriaCategoryForStatementTreeSearch',
      fetchCriteriaCategoryTreeChild: 'criteriaCategories/fetchCriteriaCategoryTreeChild',
      fetchCriteriaCategoryTree: 'criteriaCategories/fetchCriteriaCategoryTree',
      fetchStatementCriteriaCategory: 'criteriaCategories/fetchStatementCriteriaCategory',
      updateBaseState: 'statements/updateBaseState',
      createBaseState: 'statements/createBaseState',
      createNewStatement: 'statements/createStatement',
      fetchCriteriaCategories: 'criteriaCategories/fetchCriteriaCategories',
      fetchVerificationQuestions: 'verificationQuestions/fetchVerificationQuestions',
      fetchCriteriaCategory: 'criteriaCategories/fetchCriteriaCategory',
      fetchCommonData: 'partners/fetchCommonData',
      fetchSites: 'sites/fetchSites',
    }),
    siteIdChanged(siteId) {
        this.fetchCriteriaCategoryTree({ forStatement: true }).then((response) => {
          this.isLoading = false;
          this.treeData = response;
        });
        this.fetchSites({
          partnerId: this.loggedInUser.partner_id,
          pageIndex: null,
          searchTerm: '',
          orderInfo: {
            order: 'created_at',
            direction: 'ASC',
          },
          isMobile: true,
        }).then((response) => {
          this.allSite = response;
          if (this.allSite !== undefined && this.allSite.length > 0) {
            this.baseStateStatus = this.allSite.filter(x => x.id === siteId)[0].base_state_status;
            this.editable = this.baseStateStatus !== 'finalized';
            this.currentBaseStateId = this.allSite.filter(x => x.id === siteId)[0].current_base_state_id;
            this.selectedSite = this.allSite.filter(x => x.id === siteId)[0];
          }
        });
    },
    search(newTerm) {
      this.searchTerm = newTerm;
      if (this.searchTerm !== '') {
        this.isSearch = true;
        this.CriteriaCategoryForStatementTreeSearch({
          term: this.searchTerm,
          siteId: this.siteId,
        }).then((response) => {
          this.treeData = response;
          this.treeData.forEach((child, index) => {
            if (child.children && child.children.length > 0) {
              child.children.forEach((subChild, subIndex) => {
                if (subChild.children && subChild.children.length > 0) {
                  subChild.children.forEach((x) => {
                    x.main_idx = index;
                  });
                }
              });
            }
          });
        });
      } else {
        this.isSearch = false;
        this.fetchCriteriaCategoryTree({forStatement: true}).then((response) => {
          this.treeData = response;
        });
      }
    },
    clickedCreateStatement() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.statements.set_statement'),
          fields: this.statementAttributes,
          model: this.newStatement,
          submitTitle: this.$t('app.statements.buttons.save'),
          cancelTitle: this.$t('app.statements.buttons.cancel'),
          modelName: 'statements',
          hasMultipleColumn: true,
        },
        on: {
          sendAction: this.sendAction,
          submit: this.createStatement,
          modalCanceled: this.resetNewStatement,
        },
        width: '1000px',
      });
    },
    createStatement(newStatement) {
      newStatement.location_ids = newStatement.locations.filter(x => x !== null).map(x => x.id);
      newStatement.state = 0;
      newStatement.site_id = this.siteId;

      this.createNewStatement(newStatement)
        .then((response) => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.statements.success.create'),
            notificationType: 'success',
          });

          let categoryId;
          if (response.parent_category_id) {
            categoryId = response.parent_category_id;
          } else {
            categoryId = response.criteria_category_id;
          }
          this.fetchStatementCriteriaCategory();
          this.fetchCategoryById(categoryId);
          this.resetNewStatement();
          this.$eventBus.hideModal();
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    sendAction(payload) {
      if (payload.action === 'selectCategory') {
        this.fetchCriteriaCategory(payload.value).then((response) => {
          this.fetchVerificationQuestions({
            criteriaCategoryId: response.id,
            limited: true,
          }).then((verificationQuestions) => {
            this.allVerificationQuestions = verificationQuestions;
            this.clickedCreateStatement();
          });
        });
      }
      if (payload.action === 'selectSubCategory') {
        this.fetchCriteriaCategory(payload.value).then((response) => {
          this.fetchVerificationQuestions({
            criteriaCategoryId: response.id,
            limited: true,
          }).then((verificationQuestions) => {
            this.allVerificationQuestions = verificationQuestions;
            this.clickedCreateStatement();
          });
        });
      }
    },
    resetNewStatement() {
      Object.assign(this.$data.newStatement, this.$options.data().newStatement);
    },
    planBaseState() {
      this.$router.push({ name: 'BaseStatePlanningScreen', query: { siteId: this.siteId } });
    },
    newBaseState() {
      this.$swal
        .fire({
          html: this.$t('app.base_states.new_base_state_info'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t(
            'app.notifications.general_confirm.cancel',
          ),
        }).then((result) => {
          if (result.value) {
            this.$eventBus.showLoading(this.$t('app.base_states.createNewBaseStateLoading'));
            this.createBaseState({ id: this.currentBaseStateId, site_id: this.siteId }).then((response) => {
              this.baseStateStatus = response.status;
              this.currentBaseStateId = response.id;
              this.editable = this.baseStateStatus !== 'finalized';
              this.$eventBus.showNotification({
                notificationText: this.$t('app.base_states.successfull'),
                notificationType: 'success',
              });
              this.fetchCommonData(this.commonData.partner.id);
              this.$eventBus.hideLoading({});
            })
              .catch((error) => {
                this.$eventBus.hideLoading({});
                this.$swal
                  .fire({
                    html: error[0],
                    type: 'error',
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    focusConfirm: false,
                  });
              });
          }
        });
    },
    updateBaseStateStatus() {
      this.$swal
        .fire({
          html: this.$t('app.base_states.finalize_base_state_info'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t(
            'app.notifications.general_confirm.cancel',
          ),
        }).then((result) => {
          if (result.value) {
            this.$eventBus.showLoading(this.$t('app.base_states.finalizeStateLoading'));
            this.updateBaseState({
              id: this.currentBaseStateId,
              status: 'finalized',
            }).then((response) => {
              this.$eventBus.hideLoading({});
              this.baseStateStatus = response.status;
              this.currentBaseStateId = response.id;
              this.editable = this.baseStateStatus !== 'finalized';
              this.fetchCommonData(this.commonData.partner.id);
            });
          }
        });
    },
    fetchCategoryById(id) {
      this.treeData.forEach((data, index) => {
        if (data.id === id) {
          this.fetchCriteriaCategoryTreeChild({ id, forstatement: true, siteId: this.siteId }).then((response) => {
            this.treeData[index].children = [...response.statements, ...response.sub_categories];
            this.treeData[index].children.forEach((child) => {
              if (child.children && child.children.length > 0) {
                child.children.forEach((x) => {
                  x.main_idx = index;
                });
              }
            });
          });
        }
      });
    },
  },
  watch: {
  },
};
</script>

<style lang="scss">
.base-states-screen {
  .empty-section {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 40px;
  }
  .text-right {
    display: flex;
    justify-content: flex-end;
    /deep/ .base-button {
      margin-left: 10px;
    }
  }
  .extra-row {
    display: flex;
    justify-content: center;
  }
  .with-margin {
    margin-right: 40px;
  }
  .header-row, .name-col {
    padding-left: 0;
  }

  .header-row {
    color: #000000 !important;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  .rounded {
    border-radius: 4px;
  }

  .identifier-cell {
    width: 10%;
  }

  .category-cell {
    width: 10%;
  }

  .question-cell {
    width: 15%;
  }

  .statement-cell {
    width: 25%;
  }

  .location-cell {
    width: 23%;
  }

  .extra-cell {
    width: 7%;
  }

  .edit-cell {
    width: 5%;
  }

  .delete-cell {
    width: 5%;
  }

  .col-padding {
    padding-right: 5px !important;
  }

  .paragraph::after {
    font-size: 14.5px;
    content: "§";
  }

  ol, ul {
    list-style: none;
    padding: 0px;
  }

  a {
    color: #a0f6aa;
    text-decoration: none;
  }

  h1 {
    text-align: center;
    width: 90%;
    margin: 2em auto 0;
    color: #507b55;
    font-weight: bold;
  }

  .cd-accordion-menu {
    width: 100%;
    margin: 1em auto;
    background: rgba(0, 0, 0, 0.8);
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
  }

  .cd-accordion-menu li {
    user-select: none;
    background: rgba(243, 243, 243, 0.918);
  }

  .cd-accordion-menu li span {
      float: right;
  }

  .cd-accordion-menu label, .cd-accordion-menu a {
    position: relative;
    display: block;
    padding: 18px 18px 18px 45px;
    box-shadow: inset 0 -1px #cecece;
    color: #696969;
  }
  .no-touch .cd-accordion-menu label:hover,
  .no-touch .cd-accordion-menu a:hover {
    background: #52565d;
  }
  .cd-accordion-menu label::before,
  .cd-accordion-menu label::after,
  .cd-accordion-menu a::after {
    /* icons */
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .cd-accordion-menu label {
    cursor: pointer;
  }

  .cd-accordion-menu label span {
    float: right;
    color: #828282;
  }

  .title {
    float: none !important;
    color: #696969 !important;
    font-weight: 500 !important;
    margin-right: 10%;
  }


  .cd-accordion-menu label i {
    float: right;
    color: #696969;
  }

  .cd-accordion-menu li.file > label::before {
  }
  .cd-accordion-menu li.folder > label::before {
    content: "\f054";
  }

  .cd-accordion-menu li.file > label::before {
  }
  .cd-accordion-menu li.add > label::before {
    content: "\f067";
  }

  .cd-accordion-menu label::before {
    /* arrow icon */
    font: normal normal normal 14px/1 FontAwesome;
    left: 8px;
    transform: translateY(-50%);
    transition: transform 0.3s;
  }
  .cd-accordion-menu label.open::before {
    transform: translateY(-25%) rotate(90deg);
  }

  .cd-accordion-menu ul label,
  .cd-accordion-menu ul a {
    background: #000;
    box-shadow: inset 0 -1px #cecece;
    // padding-left: 82px;
  }

  .cd-accordion-menu ul label {
    background: #ffffff98  !important;
  }

  .no-touch .cd-accordion-menu ul label:hover,
  .no-touch .cd-accordion-menu ul a:hover {
    background: #3c3f45;
  }
  .cd-accordion-menu > li:last-of-type > label,
  .cd-accordion-menu > li > ul > li:last-of-type a {
    box-shadow: none;
  }
  .cd-accordion-menu ul label::before {
    left: 20px;
  }
  .cd-accordion-menu ul label::after,
  .cd-accordion-menu ul a::after {
    left: 59px;
  }
  .cd-accordion-menu ul ul label,
  .cd-accordion-menu ul ul a {
    // padding-left: 100px;
  }
  .cd-accordion-menu ul ul label::before {
    left: 54px;
  }
  .cd-accordion-menu ul ul label::after,
  .cd-accordion-menu ul ul a::after {
    left: 77px;
  }
  .cd-accordion-menu ul ul ul label,
  .cd-accordion-menu ul ul ul a {
    padding-left: 118px;
  }
  .cd-accordion-menu ul ul ul label::before {
    left: 72px;
  }
  .cd-accordion-menu ul ul ul label::after,
  .cd-accordion-menu ul ul ul a::after {
    left: 95px;
  }

  .file {
    label {
      cursor: unset;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/BaseStatesScreen.vue